import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { KeycloakAuthService } from '../auth/auth.service';

@Injectable()
export class KeycloakInterceptor implements HttpInterceptor {
  constructor(
    private keycloakAuthService: KeycloakAuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.keycloakAuthService.getToken();

    const clonedRequest = token
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      : req;

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.keycloakAuthService.logout(); 
          this.router.navigate(['Login']);
        }
        return throwError(() => error);
      })
    );
  }
}